import { useState } from 'react';
import { FileUploadBtn } from '../ui-control/fileUploadBtn';
import SilentWitnessModal from './SilentWitnessModal';
import DemandStudioSectionWarning from '../demand-studio/DemandStudioSectionWarning';
import { SilentWitnessProvider } from '../../contexts/SilentWitnessContext';
import useSilentWitnessNotifications from '../../hooks/useSilentWitnessNotifications';
import useSilentWitnessStatus from '../../hooks/useSilentWitnessStatus';
import { reportSectionClasses } from './formClasses';
import { reportBtnClasses } from './listItemClasses';

const SW_FAILURE_TITLE = 'We couldn\'t generate the Silent Witness report. Try again, and contact support if it keeps failing.';

const SilentWitness = () => {
  const [isOpen, setIsOpen] = useState(false);
  useSilentWitnessNotifications();
  const { hasFailed, errorMessage } = useSilentWitnessStatus();

  return (
    <>
      <div className={reportSectionClasses}>
        <div className={`${reportBtnClasses} p-6 mb-0!`}>
          <span>Silent Witness</span>
          <FileUploadBtn variant="link" text="Generate Report" onClick={() => setIsOpen(true)} />
        </div>
      </div>

      {hasFailed && (
        <DemandStudioSectionWarning
          title={SW_FAILURE_TITLE}
          messages={errorMessage ? [errorMessage] : []}
        />
      )}

      {isOpen && (
        <SilentWitnessProvider onClose={() => setIsOpen(false)}>
          <SilentWitnessModal />
        </SilentWitnessProvider>
      )}
    </>
  );
};

export default SilentWitness;
